<template>
  <div>
    <NavBar :admin="true" :items="items" />
    <v-main>
			<v-container>
        <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
        <template v-else>
          <v-row no-gutters class="mt-2">
            <b v-translate>Language:</b>
            <v-btn-toggle class="ml-2" v-model="language" mandatory>
              <v-btn value="pt" small class="text-overline" key="pt">
                <strong class="mr-1">PT</strong>
                <span v-translate>Portuguese</span>
              </v-btn>
              <v-btn value="en" small class="text-overline" key="en">
                <strong class="mr-1">EN</strong>
                <span v-translate>English</span>
              </v-btn>
              <v-btn value="es" small class="text-overline" key="es">
                <strong class="mr-1">ES</strong>
                <span v-translate>Spanish</span>
              </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <v-alert v-model="success" color="alert" type="success">
              <translate>Saved Successfully</translate>
            </v-alert>
            <v-alert v-model="error" color="red" type="error">
              <translate>Error</translate>
            </v-alert>
            <v-btn value="es" small color="primary" class="text-overline" key="import" @click="showImportPoint = !showImportPoint">
              Importar ponto
            </v-btn>
          </v-row>
          <v-row v-if="showImportPoint" no-gutters class="mt-2">
            <v-spacer></v-spacer>
            <SearchPoints @add-point="setInfo" :auricular="false" />
          </v-row>
          <v-form ref="generalForm">
            <v-row no-gutters class="mt-4">
              <v-col cols="12" md="12">
                <v-card>
                  <v-card-title class="primary--text" key="general">
                    <translate>General</translate>
                    <v-chip class="ml-1" small>{{point.id}}</v-chip>
                    <v-chip class="ml-1" small>{{point.side}}</v-chip>
                  </v-card-title>
                  <v-card-text>
                    <v-row no-gutters>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :rules="required"
                          v-model="point.info[language].name"
                          :label="$gettext('Name')"
                          outlined
                          class="px-2"
                        ></v-text-field>
                      </v-col>
                      <v-col v-if="point.tung" cols="12" md="6">
                        <p>Equivalente</p>
                        <AcuPointItem v-if="point.equivalent_point" :point="point.equivalent_point" @remove-point="point.equivalent_point = null" />
                        <SearchPoints v-else @add-point="setEquivalentPoint" :auricular="false" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
          <v-row v-if="point.tung" no-gutters class="mt-4">
            <v-col cols="12" md="12">
              <v-card>
                <v-card-title class="primary--text" key="indications">Grupos Clássicos</v-card-title>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="6" class="px-2">
                      <v-select
                        v-model="point.groups"
                        :items="classicGroups"
                        :label="$gettext('Groups')"
                        item-text="name"
                        item-value="id"
                        outlined
                        class="px-2"
                        :rules="required"
                        multiple
                        return-object
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col cols="12" md="12">
              <v-card>
                <v-card-title class="primary--text" v-translate key="indications">Indications</v-card-title>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" class="px-2">
                      <v-textarea
                        outlined
                        :placeholder="$gettext('Write the point indications')"
                        v-model="point.info[language].indications"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" class="mt-4 px-2">
                      <SearchICD :selectedICD="point.indications_icd" context="new-product" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col cols="12" md="12">
              <v-card>
                <v-card-title class="primary--text" v-translate key="indications">Contraindications</v-card-title>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" class="px-2">
                      <v-textarea
                        outlined
                        :placeholder="$gettext('Write the point contraindications')"
                        v-model="point.info[language].contraindications"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" class="mt-4 px-2">
                      <SearchICD :selectedICD="point.contraindications_icd" context="new-product" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col cols="12" md="12">
              <v-btn
                color="primary"
                class="float-right ml-2"
                @click="editPoint"
                :loading="loading"
              >
                <translate>Save</translate>
              </v-btn>
              <v-btn color="primary" class="float-right" :to="{name: 'admin-acu-points'}">
                <translate>Cancel</translate>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import SearchICD from "@/components/icd/SearchICD.vue";
import SearchPoints from "@/components/appointment/treatments/tcm/acupuncture/SearchPoints.vue";
import AcuPointItem from "@/components/acupuncture/AcuPointItem.vue";

export default {
  name: "EditAcuPoint",
  components: {
    NavBar,
    SearchICD,
    SearchPoints,
    AcuPointItem
  },
  data: () => ({
    language: 'pt',
    success: false,
    error: false,
    point: {
      info: {},
      indications_icd: [],
      contraindications_icd: [],
      equivalent_point: {}
    },
    loading: true,
    showImportPoint: false
  }),
  computed: {
    items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Acupuncture"),
					disabled: true,
          link: true,
          to: {name: "admin-acu-points"}
        },
        {
					name: true,
					text: this.point.id,
					disabled: true,
					link: true
				},
				{
					text: this.$gettext("Edit"),
					disabled: true,
					link: true
				}
			];
    },
    required() {
			return [v => !!v || this.$gettext("Required")];
		},
    classicGroups() {
      return [
        {
          id: 1,
          name: "LU"
        },
        {
          id: 3,
          name: "REN"
        },
        {
          id: 4,
          name: "LI"
        },
        {
          id: 5,
          name: "ST"
        },
        {
          id: 6,
          name: "SP"
        },
        {
          id: 7,
          name: "HE"
        },
        {
          id: 8,
          name: "SI"
        },
        {
          id: 9,
          name: "BL"
        },
        {
          id: 10,
          name: "KD"
        },
        {
          id: 11,
          name: "PC"
        },
        {
          id: 12,
          name: "SJ"
        },
        {
          id: 13,
          name: "GB"
        },
        {
          id: 14,
          name: "LIV"
        },
        {
          id: 15,
          name: "DU"
        }
      ]
    }
  },
  methods: {
    editPoint() {
      if (this.$refs.generalForm.validate()) {
        let indications_icd = [];
        this.point.indications_icd.forEach(icd => {
          indications_icd.push({disease_id: icd.disease_id, degree: icd.degree});
        });
        let contraindications_icd = [];
        this.point.contraindications_icd.forEach(icd => {
          contraindications_icd.push({disease_id: icd.disease_id, degree: icd.degree});
        });
        
        let data = {
          id: this.point.id,
          form: true,
          info: this.point.info,
          indications_icd: indications_icd,
          contraindications_icd: contraindications_icd,
          equivalent_point_id: this.point.equivalent_point ? this.point.equivalent_point.id : null,
          groups: this.point.groups
        }
				this.$store.dispatch("EDIT_POINT", data).then(() => {
          this.success = true;
          window.scrollTo(0, 0);
        }).catch(() => {
          this.error = true;
          window.scrollTo(0, 0);
        });
      } else {
				window.scrollTo(0, 0);
			}
    },
    setEquivalentPoint(point) {
      this.point.equivalent_point = point;
    },
    setInfo(point) {
      this.loading = true;
      this.$store.dispatch("GET_POINT_INFO", {id: point.id, form: true}).then((p) => {
        console.log(p);
        this.point.info.pt.indications = p.info.pt.indications;
        this.point.info.pt.contraindications = p.info.pt.contraindications;
        this.point.info.en.indications = p.info.en.indications;
        this.point.info.en.contraindications = p.info.en.contraindications;
        this.point.info.es.indications = p.info.es.indications;
        this.point.info.es.contraindications = p.info.es.contraindications;
        this.point.indications_icd = p.indications_icd;
        this.point.contraindications_icd = p.contraindications_icd;
        this.loading = false;
        this.showImportPoint = false;
      });
    }
  },
  created() {
    this.$store.dispatch("GET_POINT_INFO", {id: this.$route.params.pid, form: true}).then((point) => {
      this.point = point;
      this.loading = false;
		});
  }
}
</script>